import type { BreadcrumbProps } from "./breadcrumb.type";

import { Breadcrumb as AntdBreadcrumb } from "antd";
import classNames from "classnames";

import BreadcrumbItem from "./breadcrumb-item";

import "./breadcrumb.style.less";

const Breadcrumb = ({
  items,
  hideIcon,
  ellipsis,
  compact,
}: BreadcrumbProps) => {
  if (!items?.length) return null;

  let breadcrumbItems = items.map((item) => ({
    title: (
      <BreadcrumbItem item={item} hideIcon={hideIcon} ellipsis={ellipsis} />
    ),
  }));

  const length = breadcrumbItems.length;

  if (ellipsis && length > 2) {
    breadcrumbItems = [
      breadcrumbItems[0],
      { title: <div>...</div> },
      breadcrumbItems[length - 1],
    ];
  }

  return (
    <AntdBreadcrumb
      items={breadcrumbItems}
      classNames={{
        root: classNames("breadcrumb", { "breadcrumb-compact": compact }),
        item: "breadcrumb--item",
        separator: "breadcrumb--separator",
      }}
    />
  );
};

export default Breadcrumb;
